<template>
  <div class="application-card">
    <div class="application-card--header">
      <div class="application-card--media">
        <img v-if="avatarUrl" :src="avatarUrl" :alt="name" />
        <img
          v-else
          class="woot-thumbnail"
          src="~dashboard/assets/images/chatwoot_bot.png"
          alt="Avatar Padrão"
        />
      </div>
      <h3 class="application-card--title">
        {{ name }}
      </h3>
    </div>
    <p class="application-card--description">
      {{ description }}
    </p>
    <div
      class="application-card--footer"
      :class="{ 'is-busy': isBusy && !isLoading }"
    >
      <woot-button
        size="small"
        :color-scheme="isEnabled ? 'alert' : 'primary'"
        :is-loading="isLoading"
        :aria-disabled="isBusy"
        @click="$emit('toggle')"
      >
        {{
          isEnabled
            ? $t('INTEGRATION_SETTINGS.ASSISTENT.PUBLIC_KNOWLEDGE_BASE.DISABLE')
            : $t('INTEGRATION_SETTINGS.ASSISTENT.PUBLIC_KNOWLEDGE_BASE.ENABLE')
        }}
      </woot-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    avatarUrl: {
      type: String,
      default: '',
    },
    isEnabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isBusy: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
.application-card {
  background: var(--white);
  border: 1px solid var(--s-75);
  border-radius: var(--border-radius-normal);
  display: flex;
  flex-direction: column;
  height: 100%;
  min-width: 0;
  padding: var(--space-normal);
}

.application-card--header {
  align-items: center;
  display: flex;
  gap: var(--space-small);
  margin-bottom: var(--space-small);
}

.application-card--media {
  align-items: center;
  display: flex;
  flex-shrink: 0;
  height: var(--space-medium);
  justify-content: center;
  width: var(--space-medium);

  img {
    max-height: 100%;
    max-width: 100%;
  }
}

.application-card--title {
  font-size: var(--font-size-default);
  font-weight: var(--font-weight-medium);
  margin: 0;
  min-width: 0;
  overflow-wrap: anywhere;
}

.application-card--description {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  color: var(--s-600);
  display: -webkit-box;
  flex: 1;
  font-size: var(--font-size-small);
  line-height: 1.5;
  margin-bottom: var(--space-normal);
  min-height: calc(4 * 1.5em);
  overflow: hidden;
}

.application-card--footer {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;

  &.is-busy {
    cursor: progress;

    .button {
      pointer-events: none;
    }
  }
}
</style>
